import { __decorate } from 'tslib';
import { InjectionToken, Input, Directive, forwardRef, NgModule, ChangeDetectorRef } from '@angular/core';
import { TuiController, tuiDefaultProp, TuiDestroyService } from '@taiga-ui/cdk';
import { DEFAULT_MIN_HEIGHT, DEFAULT_MAX_HEIGHT } from '@taiga-ui/core/constants';
import { watchedControllerFactory } from '@taiga-ui/core/providers';

import * as ɵngcc0 from '@angular/core';
const TUI_DROPDOWN_CONTROLLER = new InjectionToken('Controls configuration of hints', {
    factory: () => new TuiDropdownControllerDirective(),
});

var TuiDropdownControllerDirective_1;
let TuiDropdownControllerDirective = TuiDropdownControllerDirective_1 = class TuiDropdownControllerDirective extends TuiController {
    constructor() {
        super(...arguments);
        this.align = 'right';
        this.direction = null;
        this.limitWidth = 'auto';
        this.minHeight = DEFAULT_MIN_HEIGHT;
        this.maxHeight = DEFAULT_MAX_HEIGHT;
        this.sided = false;
    }
};
TuiDropdownControllerDirective.ɵfac = function TuiDropdownControllerDirective_Factory(t) { return ɵTuiDropdownControllerDirective_BaseFactory(t || TuiDropdownControllerDirective); };
TuiDropdownControllerDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TuiDropdownControllerDirective, selectors: [["", "tuiDropdownAlign", ""], ["", "tuiDropdownDirection", ""], ["", "tuiDropdownLimitWidth", ""], ["", "tuiDropdownMinHeight", ""], ["", "tuiDropdownMaxHeight", ""], ["", "tuiDropdownSided", ""]], inputs: { align: ["tuiDropdownAlign", "align"], direction: ["tuiDropdownDirection", "direction"], limitWidth: ["tuiDropdownLimitWidth", "limitWidth"], minHeight: ["tuiDropdownMinHeight", "minHeight"], maxHeight: ["tuiDropdownMaxHeight", "maxHeight"], sided: ["tuiDropdownSided", "sided"] }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_DROPDOWN_CONTROLLER,
                useExisting: forwardRef(() => TuiDropdownControllerDirective_1)
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
__decorate([
    Input('tuiDropdownAlign'),
    tuiDefaultProp()
], TuiDropdownControllerDirective.prototype, "align", void 0);
__decorate([
    Input('tuiDropdownDirection'),
    tuiDefaultProp()
], TuiDropdownControllerDirective.prototype, "direction", void 0);
__decorate([
    Input('tuiDropdownLimitWidth'),
    tuiDefaultProp()
], TuiDropdownControllerDirective.prototype, "limitWidth", void 0);
__decorate([
    Input('tuiDropdownMinHeight'),
    tuiDefaultProp()
], TuiDropdownControllerDirective.prototype, "minHeight", void 0);
__decorate([
    Input('tuiDropdownMaxHeight'),
    tuiDefaultProp()
], TuiDropdownControllerDirective.prototype, "maxHeight", void 0);
__decorate([
    Input('tuiDropdownSided'),
    tuiDefaultProp()
], TuiDropdownControllerDirective.prototype, "sided", void 0);

let TuiDropdownControllerModule = class TuiDropdownControllerModule {
};
TuiDropdownControllerModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TuiDropdownControllerModule });
TuiDropdownControllerModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TuiDropdownControllerModule_Factory(t) { return new (t || TuiDropdownControllerModule)(); } });
const ɵTuiDropdownControllerDirective_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(TuiDropdownControllerDirective);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiDropdownControllerDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiDropdownAlign], [tuiDropdownDirection], [tuiDropdownLimitWidth], [tuiDropdownMinHeight], [tuiDropdownMaxHeight], [tuiDropdownSided]',
                providers: [
                    {
                        provide: TUI_DROPDOWN_CONTROLLER,
                        useExisting: forwardRef(() => TuiDropdownControllerDirective_1)
                    },
                ]
            }]
    }], null, { align: [{
            type: Input,
            args: ['tuiDropdownAlign']
        }], direction: [{
            type: Input,
            args: ['tuiDropdownDirection']
        }], limitWidth: [{
            type: Input,
            args: ['tuiDropdownLimitWidth']
        }], minHeight: [{
            type: Input,
            args: ['tuiDropdownMinHeight']
        }], maxHeight: [{
            type: Input,
            args: ['tuiDropdownMaxHeight']
        }], sided: [{
            type: Input,
            args: ['tuiDropdownSided']
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiDropdownControllerModule, { declarations: [TuiDropdownControllerDirective], exports: [TuiDropdownControllerDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiDropdownControllerModule, [{
        type: NgModule,
        args: [{
                declarations: [TuiDropdownControllerDirective],
                exports: [TuiDropdownControllerDirective]
            }]
    }], null, null); })();

const TUI_DROPDOWN_WATCHED_CONTROLLER = new InjectionToken('watched dropdown controller');
// TODO: remove in ivy compilation
const DROPDOWN_CONTROLLER_FACTORY = watchedControllerFactory;
const DROPDOWN_CONTROLLER_PROVIDER = [
    TuiDestroyService,
    {
        provide: TUI_DROPDOWN_WATCHED_CONTROLLER,
        deps: [TUI_DROPDOWN_CONTROLLER, ChangeDetectorRef, TuiDestroyService],
        useFactory: DROPDOWN_CONTROLLER_FACTORY,
    },
];

/**
 * Generated bundle index. Do not edit.
 */

export { DROPDOWN_CONTROLLER_FACTORY, DROPDOWN_CONTROLLER_PROVIDER, TUI_DROPDOWN_CONTROLLER, TUI_DROPDOWN_WATCHED_CONTROLLER, TuiDropdownControllerDirective, TuiDropdownControllerModule };

//# sourceMappingURL=taiga-ui-core-directives-dropdown-controller.js.map